<shared-ui-modal-base-modal
  [cancelButtonTitle]="'button-close' | translate"
  [confirmButtonTitle]="'button-change' | translate"
  [canConfirm]="true"
  [confirmButtonDisabled]="!this.pinForm.valid"
  [title]="'modal-change-pin-title' | translate"
  (confirmOutput)="onChangeClick()"
>
  <div>
    <form [formGroup]="pinForm">
      <shared-ui-inputs-input-group [parentFormGroup]="pinForm" [formName]="'pin'" [name]="'input-new-pin' | translate" [type]="inputType" [display]="inputFieldDisplay">
      </shared-ui-inputs-input-group>
      <br />
      <shared-ui-inputs-input-group [parentFormGroup]="pinForm" [formName]="'confirmPin'" [name]="'input-confirm-pin' | translate" [type]="inputType" [display]="inputFieldDisplay">
      </shared-ui-inputs-input-group>
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-10">
          <div *ngIf="pinForm.hasError('notMatch')">
            <div class="invalid-feedback d-block">{{ 'default-not-matched-field' | translate }}</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</shared-ui-modal-base-modal>
